import { render } from "./Index.vue?vue&type=template&id=b4082c48&ts=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=b4082c48&lang=scss"
import "./Index.vue?vue&type=style&index=1&id=b4082c48&lang=scss&scope=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__